/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {ModalExampleStandard, ModalExampleStateOnly, ModalExampleCloseByHandler} from 'Docs/uilib/components/modal/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    h3: "h3",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsxs(_components.p, {
      children: ["The following examples are to demonstrate the functionality of Modal. Please go to ", _jsx(_components.a, {
        href: "/uilib/components/drawer/demos",
        children: "Drawer demos"
      }), " or ", _jsx(_components.a, {
        href: "/uilib/components/dialog/demos",
        children: "Dialog demos"
      }), " for complete component demos."]
    }), "\n", _jsx(_components.h3, {
      children: "Example"
    }), "\n", _jsx(ModalExampleStandard, {}), "\n", _jsx(_components.h3, {
      children: "Open Modal by the state only"
    }), "\n", _jsxs(_components.p, {
      children: ["Use a custom trigger button and state handling by setting ", _jsx(_components.code, {
        children: "omitTriggerButton"
      }), " to Modal."]
    }), "\n", _jsx(ModalExampleStateOnly, {}), "\n", _jsx(_components.h3, {
      children: "Close Modal by handlers"
    }), "\n", _jsxs(_components.p, {
      children: ["Use the ", _jsx(_components.code, {
        children: "close_modal"
      }), " prop to set another close handler, like a timeout for when the modal should close."]
    }), "\n", _jsx(ModalExampleCloseByHandler, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
